const themes = {
  CLASSIC: 'classic',
  STORY: 'story',
};

export const { CLASSIC, STORY } = themes;
